import React from 'react';

import { CloseButton, CloseButtonColor, CloseButtonSize } from '../../DesignSystem/LiliCloseButton/CloseButton';
import { useWizardContext } from './logic/WizardContext';
import { SSNStep } from './steps/SsnStep';
import { CardStep } from './steps/CardStep';
import { MailStep } from './steps/MailStep';
import { PhoneStep } from './steps/PhoneStep';
import ChangePhoneHeader from './ChangePhoneHeader';
import { ErrorView } from './steps/ErrorView';
import { useStore } from '../../store';

export enum ChangePhoneFlow {
  SSN,
  CREDIT_CARD,
  MAIL_VERIFICATION,
  PHONE_INPUT,
  ERROR,
  NONE,
}
export interface ChangePhoneProps {
  onClose: () => void;
}
export const ChangePhoneSteps = ({ onClose }: ChangePhoneProps) => {
  const { step } = useWizardContext();
  const {
    customer: { nationalIdDescription },
  } = useStore((state) => state.summary);

  const renderMap: { [key in ChangePhoneFlow]: React.ReactNode } = {
    [ChangePhoneFlow.SSN]: <SSNStep nationalIdDescription={nationalIdDescription} />,
    [ChangePhoneFlow.CREDIT_CARD]: <CardStep />,
    [ChangePhoneFlow.MAIL_VERIFICATION]: <MailStep />,
    [ChangePhoneFlow.PHONE_INPUT]: <PhoneStep onClose={onClose} />,
    [ChangePhoneFlow.ERROR]: <ErrorView onClose={onClose} />,
    [ChangePhoneFlow.NONE]: <div />,
  };

  return (
    <div>
      <div className='flex flex-col bg-bw01 rounded-[12px] height-[460px]  animate-fadeIn px-[32px] pt-[32px] pb-[32px] w-[504px] '>
        <CloseButton
          onClick={onClose}
          id='closeButton'
          color={CloseButtonColor.Black}
          size={CloseButtonSize.Medium}
          className='absolute top-[16px] right-[16px] w-[0.625rem] h-[0.625rem] cursor-pointer z-10'
        />
        <ChangePhoneHeader />
        <div className='flex flex-col justify-center items-center  '>{renderMap[step as ChangePhoneFlow]}</div>
      </div>
    </div>
  );
};
